import React from 'react';
import { scrollVisibilityApiType } from './Carousel';

export function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
  const scrolledHorizontally = Math.abs(ev.deltaX) !== 0;
  const scrolledaVerySmallVerticalStep = Math.abs(ev.deltaY) < 15;
  const isThouchpad = scrolledHorizontally || scrolledaVerySmallVerticalStep;

  if (isThouchpad) {
    ev.stopPropagation();
    return;
  }

  const scrolledDown = ev.deltaY < 0;
  const scrolledUp = ev.deltaY > 0;
  if (scrolledDown) {
    apiObj.scrollNext();
  }
  if (scrolledUp) {
    apiObj.scrollPrev();
  }
}
